var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "filter_svg__linesandangles_een",
    d: "M26 6v.233l-8.487 9.43-.513.57v8.531l-2-1V16.233l-.513-.57L6 6.233V6h20m2-2H4v3l9 10v8l6 3V17l9-10V4z",
    fill: "#666"
  })));
}
export default SvgFilter;